import InputBoilerplate from "../InputBoilerplate"

function PasswordInput({label, inputName, placeholder, setState}) {
  return (
    <InputBoilerplate
        label={label}
        type={'password'}
        inputName={inputName}
        placeholder={placeholder}
        setState={setState}
    />
  )
}

export default PasswordInput